export default {
  // Index
  pageNotFound: {
    english: "Page Not Found",
    spanish: "Página no encontrada",
  },
  // sorry listed in error-page
  // back listed in order-form
};
